import { Subject } from "rxjs";

var doctorListData: any;
let doctorListUpdate = new Subject<any>();

const getDoctorListData = doctorListUpdate.asObservable();

const setDoctorListDataFromComponent = (doctorData: any) => {
  doctorListData = doctorData;
};

const getDoctorListDataFromComponent = () => {
  return doctorListData;
};
// get the doctor list after deletion
const updateDoctorList = (data: any) => {
  doctorListUpdate.next(data);
};

export const sBoardProviderService = {
  setDoctorListDataFromComponent,
  getDoctorListDataFromComponent,
  updateDoctorList,
  getDoctorListData,
  doctorListUpdate,
};
